var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconWarningColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.973 23.31H1.351a1.35 1.35 0 01-1.167-2.032L10.995 2.36a1.351 1.351 0 012.335 0l10.81 18.92a1.352 1.352 0 01-1.167 2.032z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.81 19.353c0-.182.033-.348.097-.504.064-.154.155-.288.273-.4.115-.114.258-.202.421-.266.165-.062.35-.095.557-.095.207 0 .393.033.56.095a1.205 1.205 0 01.699.666c.065.156.097.322.097.504s-.032.348-.097.5a1.184 1.184 0 01-.7.662 1.588 1.588 0 01-.559.093 1.55 1.55 0 01-.557-.094 1.272 1.272 0 01-.421-.265 1.165 1.165 0 01-.273-.397 1.254 1.254 0 01-.096-.5zm2.352-2.799h-2.009l-.284-8.108h2.577l-.284 8.108z",
    fill: "#5D4037"
  }))));
}

export default SvgCommonIconWarningColor;